<template>
  <div class="bg-grey-lines block-fullscreen">
    <div class="header-logo">
      <icon name="td-logo" color="#393f49" />
    </div>
    <section class="block-fullscreen-center block-fullscreen-text">
      <h1 class="title-section">CULTURA E LIDERANÇA</h1>
      <div class="title-main">
        <p>Para que a transformação digital aconteça de maneira efetiva é necessário que as pessoas estejam abertas a uma nova forma de pensar, criando uma cultura digital e formando líderes dispostos a encarar os desafios que surgem nesse novo contexto.</p>
        <p>Vamos começar analisando questões relacionadas ao seu mindset, aspectos de liderança e inovação.</p>
      </div>
      <router-link to="/teste/cultura-e-lideranca/formulario" class="nav-arrow-down">
        <div class="title hidden-sm">
          Role para baixo
        </div>
        <icon name="arrow-line-right" class="arrow-right animation-blink" />
      </router-link>
    </section>
  </div>
</template>

<script>
import Icon from '../Icon';
import rollDown from '../mixins/rollDown';

/* eslint-disable max-len */
export default {
  name: 'cultura_e_lideranca',
  mixins: [rollDown],
  components: { Icon },
  data() {
    return {
      nextScreen: '/teste/cultura-e-lideranca/formulario',
    };
  },
  mounted() {
    this.$store.commit('SET_BAR_PROGRESS', 2);
  }
};
</script>



// WEBPACK FOOTER //
// src/components/test/CultureAndLeadership.vue